import { useMutation } from "@tanstack/react-query";
import { NewPackageFormData } from "components/staff/Packages/NewPackageForm";
import { PackageAmount, StaffPackage } from "models/packages";
import { useAuthenticatedRequestCreator } from "./useRequests";

const useCreatePackage = () => {
    const createPackageCreator = useAuthenticatedRequestCreator<StaffPackage, NewPackageFormData>(formData => ({
        method: "post",
        url: "/packages/new",
        data: {
            senderUserId: formData.owners.customers[0]!.id,
            customerIds: formData.owners.customers.map(c => c!.id),
            packageTypeId: formData.packageType.id,
            amount: formData.amount ?? PackageAmount.NotApplicable,
            accountIds: formData.owners.silentUsers.map(u => u!.accountId),
            trackingNumberSuffix: formData.trackingNumberSuffix?.trim() !== ''
                ? formData.trackingNumberSuffix
                : null,
            scanRowCount: formData.scanRowCount,
            nonScanRowCount: formData.nonScanRowCount
        }
    }), [400]);

    const { mutateAsync: createPackage, isLoading: working } = useMutation(
        (formData: NewPackageFormData) => createPackageCreator(formData)
    );

    return { createPackage, working };
};

export default useCreatePackage;
